import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputGroup, InputGroupText, InputGroupAddon, Input } from 'reactstrap';
import NavBarItem from './navBarItem';
import './navBar.css';

import logo from '../../resources/Barline@2x.png';
import logout from '../../resources/Logout.svg';
import leads from '../../resources/Leads.svg';
import globalIcon from '../../resources/Feeds.svg';
import profile from '../../resources/Profile.svg';

class navBar extends Component {
  constructor(props) {
    super(props);

    this.state = { selected: '', searchTerm: '' };
  }

  componentWillReceiveProps = (newProps) => {
    const { selected } = newProps;
    this.setState({ selected });
  };

  logOut = () => {
    const { logOut } = this.props;
    logOut();
  };

  searchChanged = (event) => {
    this.setState({ searchTerm: event.target.value });
  };

  render() {
    const {
      options,
      onClick,
      showGlobal,
      saveChanges,
      publishChanges,
      summary,
      canSave,
      canPublish,
      isAdmin,
      exportToCSV,
      redirectToUserAdministration,
      importFromCSV,
    } = this.props;
    const { selected, searchTerm } = this.state;

    return (
      <div className='navBar'>
        <div className='navBar-item nohover'>
          <img alt='logo-barline' className='logo-barline' src={logo} />
        </div>
        <div className='separator' />
        <div className='navBar-item nohover'>
          <InputGroup>
            <Input
              onChange={this.searchChanged}
              value={searchTerm}
              placeholder='Menu Search...'
            />
            <InputGroupAddon addonType='append'>
              <InputGroupText>
                <FontAwesomeIcon icon={['fas', 'search']} />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </div>
        <div className='separator' />
        {!options ? (
          <div className='spinner'>
            <FontAwesomeIcon icon={['fas', 'spinner']} spin size='4x' />{' '}
          </div>
        ) : (
          ''
        )}
        {options &&
        showGlobal &&
        'global'.includes(searchTerm.toLowerCase()) ? (
          <NavBarItem
            key='Global'
            img={globalIcon}
            label='Global'
            selected={selected === 'Global'}
            onClick={onClick}
            warning={summary && summary.global && summary.global.warning}
            empty={summary && summary.global && summary.global.empty}
            unpublished={
              summary && summary.global && summary.global.unpublished
            }
            basechanged={
              summary && summary.global && summary.global.basechanged
            }
          />
        ) : (
          ''
        )}
        <div className='separator' />
        {options &&
          options
            .filter((item) =>
              item.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .sort()
            .map((item) => (
              <NavBarItem
                key={item}
                img={leads}
                label={item}
                selected={item === selected}
                onClick={onClick}
                warning={
                  summary &&
                  summary.pages &&
                  summary.pages[item] &&
                  summary.pages[item].warning
                }
                empty={
                  summary &&
                  summary.pages &&
                  summary.pages[item] &&
                  summary.pages[item].empty
                }
                unpublished={
                  summary &&
                  summary.pages &&
                  summary.pages[item] &&
                  summary.pages[item].unpublished
                }
                basechanged={
                  summary &&
                  summary.pages &&
                  summary.pages[item] &&
                  summary.pages[item].basechanged
                }
              />
            ))}
        <div className='separator' />
        {options && exportToCSV && (
          <Fragment>
            <NavBarItem
              icon={['fas', 'file-export']}
              action
              label='Import from CSV'
              selected={false}
              onClick={importFromCSV}
            />
            <NavBarItem
              icon={['fas', 'file-import']}
              action
              label='Export to CSV'
              selected={false}
              onClick={exportToCSV}
            />
          </Fragment>
        )}
        <div className='separator' />
        {options && canSave && (
          <NavBarItem
            icon='save'
            action
            label='Save Changes'
            selected={false}
            onClick={saveChanges}
          />
        )}
        {options && canPublish && (
          <NavBarItem
            icon='globe'
            action
            label='Publish'
            selected={false}
            onClick={publishChanges}
          />
        )}
        <div className='separator' />
        {isAdmin && (
          <NavBarItem
            img={profile}
            action
            label='User Management'
            selected={false}
            onClick={() => redirectToUserAdministration(true)}
          />
        )}
        <div className='separator' />
        <NavBarItem
          img={logout}
          action
          label='Logout'
          selected={false}
          onClick={this.logOut}
        />

        <div className='separator' />
        <div className='navBar-version'>
          <small>v1.5.1</small>
        </div>
      </div>
    );
  }
}

export default navBar;
